import classNames from "classnames";
import PropTypes from "prop-types";

export const ChevronLeftIcon = ({ className, size = 20, ...props }) => {
	const iconClassName = classNames("chevron-left-icon", className);

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			className={iconClassName}
			{...props}
		>
			<path
				d="M12.7461 3.92118C13.0705 4.24559 13.0707 4.77151 12.7466 5.09618L7.85007 10.0001L12.7466 14.9041C13.0707 15.2287 13.0705 15.7546 12.7461 16.0791C12.4215 16.4037 11.8953 16.4037 11.5707 16.0791L6.08099 10.5894C5.75555 10.2639 5.75556 9.7363 6.08099 9.41086L11.5707 3.92118C11.8953 3.59659 12.4215 3.59659 12.7461 3.92118Z"
				fill="currentColor"
			/>
		</svg>
	);
};

ChevronLeftIcon.propTypes = {
	className: PropTypes.string,
	size: PropTypes.number,
};
